import {
  Box,
  Button,
  Container,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useMutation } from "@apollo/client";
import { Block } from "../sections/_examples/Block";
import Iconify from "../components/iconify/Iconify";
import { PRIMARY } from "../theme/palette";
import GoogleConfig from "../sections/mail/GoogleConfig";
import OutlookConfig from "../sections/mail/OutlookConfig";
import { useAuthContext } from "../sections/auth/useAuthContext";
import { UPDATE_USER_TIMEZONE_MUTATION } from "../sections/auth/graphql";
import { COMMON_IANA_TIMEZONES, DEFAULT_SITE_TIMEZONE } from "../utils/dateTimezone";
import SMS from "../sections/sms/SMS";
import MailChimp from "../sections/mailchimp/MailChimp";
import axios from "axios";
import { useSnackbar } from "notistack";

const style = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "left",
  "& > *": { mx: "8px !important" },
};

export default function Settings() {
  const [currentTab, setCurrentTab] = useState("preferences");
  const [emailSelect, setEmailSelect] = useState("gmail");
  const [email, setEmail] = useState("");
  const [sms, setSMSNumber] = useState("");
  const { user, refreshUser } = useAuthContext();
  const [userTimezone, setUserTimezone] = useState(user?.userTimezone || DEFAULT_SITE_TIMEZONE);
  const { enqueueSnackbar } = useSnackbar();
  const [updateUserTimezone, { loading: timezoneLoading }] = useMutation(
    UPDATE_USER_TIMEZONE_MUTATION,
    {
      onCompleted: (data) => {
        if (data?.updateUserTimezone?.success) {
          refreshUser?.();
          enqueueSnackbar("Time zone saved.", { variant: "success" });
        } else {
          enqueueSnackbar(data?.updateUserTimezone?.errors?.[0] || "Failed to save time zone", {
            variant: "error",
          });
        }
      },
      onError: (err) => {
        enqueueSnackbar(err?.message || "Failed to save time zone", { variant: "error" });
      },
    }
  );
  let ring_central_user_data = localStorage.getItem("ring_central_user_data");

  const IsConnected = () => {
    if (
      emailSelect === "gmail" &&
      user &&
      user.access_token_data?.google_access_token?.length
    ) {
      return "Connected";
    } else if (
      emailSelect === "outlook" &&
      user &&
      user.access_token_data?.outlook_access_token?.length
    ) {
      return "Connected";
    }
  };

  const TABS = [
    {
      value: "preferences",
      icon: <Iconify icon="eva:options-2-outline" width={24} />,
      label: "Preferences",
    },
    {
      value: "email",
      icon: <Iconify icon="eva:heart-fill" width={24} />,
      label: "Email",
    },
  ];

  const handleTag = () => {
    console.log("add tags");
  };

  const handleTimezoneSave = () => {
    if (!user?.id || !userTimezone) return;
    updateUserTimezone({
      variables: {
        data: { userId: user.id, userTimezone },
      },
    });
  };

  const handleTabs = (item) => {
    switch (item) {
      case "preferences":
        return (
          <div>
            <Typography
              sx={{
                fontWeight: 700,
                padding: "15px 0",
                fontSize: "25px",
                lineHeight: "26px",
              }}
            >
              Preferences
            </Typography>
            <Typography sx={{ mb: 1 }}>Time zone for displaying dates and times across the app.</Typography>
            <Select
              value={userTimezone}
              onChange={(e) => setUserTimezone(e.target.value)}
              sx={{ width: "100%", maxWidth: 320, marginBottom: 2 }}
              size="medium"
              displayEmpty
            >
              {COMMON_IANA_TIMEZONES.map((tz) => (
                <MenuItem key={tz} value={tz}>
                  {tz}
                </MenuItem>
              ))}
            </Select>
            <Box>
              <Button
                variant="contained"
                onClick={handleTimezoneSave}
                disabled={timezoneLoading}
              >
                {timezoneLoading ? "Saving…" : "Save time zone"}
              </Button>
            </Box>
          </div>
        );
      case "email":
        return (
          <div>
            <Typography
              sx={{
                fontWeight: 700,
                padding: "15px 0",
                fontSize: "25px",
                lineHeight: "26px",
              }}
            >
              Email Configuration
            </Typography>
            <Box>
              <Select
                value={emailSelect}
                onChange={(e) => setEmailSelect(e.target.value)}
                sx={{ width: "100%", marginBottom: "20px" }}
                size="large"
              >
                <MenuItem value="gmail">Gmail</MenuItem>
                <MenuItem value="outlook">Outlook</MenuItem>
              </Select>
              <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ width: "100%" }}
                placeholder="Add Email"
              />
            </Box>
            {IsConnected()}
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "",
                margin: "15px 0",
              }}
            >
              {emailSelect === "gmail" ? <GoogleConfig /> : <OutlookConfig />}
            </Box>
          </div>
        );
      case "sms":
        return (
          <div>
            <Typography
              sx={{
                fontWeight: 700,
                padding: "15px 0",
                fontSize: "25px",
                lineHeight: "26px",
              }}
            >
              SMS Configuration
            </Typography>
            <TextField value={sms} disabled sx={{ width: "100%" }} />
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
                margin: "15px 0",
              }}
            >
              <SMS />
            </Box>
          </div>
        );
      case "mailchimp":
        return (
          <div>
            <Typography
              sx={{
                fontWeight: 700,
                padding: "15px 0",
                fontSize: "25px",
                lineHeight: "26px",
              }}
            >
              MailChimp
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column", // Set the direction to column
                alignItems: "flex-start", // Align items to the start
                margin: "15px 0",
              }}
            >
              <MailChimp user={user} />
            </Box>
          </div>
        );

      case "advCredit":
        return (
          <div>
            <Typography
              sx={{
                fontWeight: 700,
                padding: "15px 0",
                fontSize: "25px",
                lineHeight: "26px",
              }}
            >
              Advanced Credit Configuration
            </Typography>
           
          </div>
        );

      default:
        break;
    }
  };

  useEffect(() => {
    if (ring_central_user_data) {
      setSMSNumber(JSON.parse(ring_central_user_data)?.phoneNumber);
    }
  }, [ring_central_user_data]);

  useEffect(() => {
    setEmail(user?.email);
  }, [user]);

  useEffect(() => {
    setUserTimezone(user?.userTimezone || DEFAULT_SITE_TIMEZONE);
  }, [user?.userTimezone]);

  return (
    <>
      <Helmet>
        <title>User Setting</title>
      </Helmet>
      <Container maxWidth={false}>
        <Block sx={style}>
          <Tabs
            value={currentTab}
            onChange={(event, newValue) => setCurrentTab(newValue)}
            variant="scrollable"
            orientation="vertical"
            sx={{
              border: `0.5px solid ${PRIMARY.gray}`,
              borderRadius: "5px",
              display: "flex",
              width: "100%",
              maxWidth: "250px",
              span: { display: "none" },
            }}
          >
            {TABS.map((tab) => (
              <Tab
                key={tab.value}
                value={tab.value}
                sx={{
                  background: `${currentTab === tab.value ? PRIMARY.blue : ""}`,
                  color: `${
                    currentTab === tab.value
                      ? `${PRIMARY.light} !important`
                      : ""
                  }`,
                  display: "flex",
                  alignItems: "flex-start",
                  padding: "20px",
                }}
                label={tab.label}
              />
            ))}
          </Tabs>

          {TABS.map(
            (tab) =>
              tab.value === currentTab && (
                <Box
                  key={tab.value}
                  sx={{
                    p: 2,
                    borderRadius: 1,
                    bgcolor: "background.neutral",
                    border: `1px solid ${PRIMARY.gray}`,
                    width: "100%",
                    height: "675px",
                  }}
                >
                  {handleTabs(tab.value)}
                </Box>
              )
          )}
        </Block>
      </Container>
    </>
  );
}
